<template>
<nav id="navbar">
  <div class="nav-bg"></div>
  <div class="container">
    <div class="brand">
      <h1>lorenzopr</h1>
    </div>
    <div :class="{btns: true, open: menuShown}">
      <nav-button @click.native="closeMenu('#header', 0)" :active="menuSelected == '#header'">
        Home
      </nav-button>
      <nav-button @click.native="closeMenu('#projs', -85)" :active="menuSelected == '#projs'">
        Projects
      </nav-button>
      <nav-button @click.native="closeMenu('#contact', -85)" :active="menuSelected == '#contact'">
        Contact Me
      </nav-button>
    </div>
    <div class="mobile_menu" @click="toggle">
      <i class="fas fa-bars fa-fw"></i>
    </div>
  </div>
</nav>
</template>

<script>
import VueScrollTo from 'vue-scrollto';
import NavButton from './NavButton';

export default {
  name: 'Navbar',
  components: {
    NavButton,
  },
  computed: {
    menuShown() {
      return this.$store.getters.getMenuState;
    },
    menuSelected() {
      return this.$store.getters.getSelected;
    },
    alertOrModal() {
      return this.$store.getters.getAlertState || this.$store.getters.getModalState;
    },
  },
  methods: {
    toggle() {
      this.$store.commit('toggleMenu');
    },
    closeMenu(to, off) {
      if (!this.alertOrModal) {
        VueScrollTo.scrollTo(to, 500, { offset: this.menuShown ? -150 + off : off });
        this.$store.commit('setMenuState', false);
        this.$store.commit('setSelected', to);
      }
    },
  },
};
</script>

<style lang="scss">
#navbar {
  height: 60px;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  z-index: 9999;
  .nav-bg {
    position: absolute;
    background: $dark_bg;
    box-shadow: 0 3px 6px rgba(#000, .35);
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
  .container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 100%;
    z-index: 2;
    .brand {
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      h1 {
        margin: 0;
        color: $text_gray;
        font-weight: normal;
        font-size: 25px;
        cursor: default;
      }
    }
    .btns {
      height: 100%;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      z-index: 3;
    }
    .mobile_menu {
      display: none;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      top: 15px;
      right: 15px;
      cursor: pointer;
      z-index: 3;
      i {
        color: $text_gray;
        font-size: 35px;
      }
    }
  }
}

@media screen and (max-width: 500px) {
  #navbar {
    .nav-bg {
      box-shadow: 0 3px 6px transparent;
    }
    .container {
      .btns {
        flex-direction: column;
        position: absolute;
        top: -90px;
        left: 0;
        //height: 0;
        height: auto;
        z-index: -2;
        width: 100%;
        transition: transform .2s ease;
        box-shadow: 0 3px 6px rgba(#000, .35);
        &.open {
          //height: auto !important;
          transform: translateY(150px);
        }
      }
      .mobile_menu {
        display: flex;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar/Navbar.vue